module.exports = __webpack_public_path__ + "static/media/harmonies-4.bf94e9dd.jpg";